import { FC } from 'react';

type SettingsIconProps = {
  width?: number | string;
  height?: number | string;
  active?: boolean;
  disable?: boolean;
};

const SettingsIcon: FC<SettingsIconProps> = ({
  width = 34,
  height = 34,
  active = false,
  disable = false,
}) => {
  const circleFill = active ? '#561BDC' : disable ? '#D5D5D5' : '#FAFAFA';
  const strokeColor = active ? '#EDEDED' : disable ? '#8E8E8E' : '#1A1A1A';

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 34 34"
    >
      <circle cx="17" cy="17" r="17" fill={circleFill} />
      <g transform="translate(14 14)">
        <path
          d="M13.257,2.145A4.762,4.762,0,0,0,11.572,2a4.762,4.762,0,0,0-1.685.145A1.909,1.909,0,0,0,8.853,3.179,2.353,2.353,0,0,0,8.717,4a1.509,1.509,0,0,1-2.25,1.3,2.353,2.353,0,0,0-.782-.294,1.909,1.909,0,0,0-1.411.378A4.761,4.761,0,0,0,3.3,6.773,4.761,4.761,0,0,0,2.588,8.3a1.909,1.909,0,0,0,.378,1.411,2.352,2.352,0,0,0,.645.53,1.509,1.509,0,0,1,0,2.6,2.354,2.354,0,0,0-.645.53,1.909,1.909,0,0,0-.378,1.411A4.761,4.761,0,0,0,3.3,16.319a4.761,4.761,0,0,0,.968,1.387,1.909,1.909,0,0,0,1.411.378,2.354,2.354,0,0,0,.782-.294,1.509,1.509,0,0,1,2.25,1.3,2.353,2.353,0,0,0,.137.824,1.909,1.909,0,0,0,1.033,1.033,4.763,4.763,0,0,0,1.685.145,4.763,4.763,0,0,0,1.685-.145,1.909,1.909,0,0,0,1.033-1.033,2.352,2.352,0,0,0,.137-.824,1.509,1.509,0,0,1,2.25-1.3,2.353,2.353,0,0,0,.782.294,1.909,1.909,0,0,0,1.411-.378,4.761,4.761,0,0,0,.968-1.387,4.76,4.76,0,0,0,.717-1.532,1.909,1.909,0,0,0-.378-1.411,2.353,2.353,0,0,0-.645-.53,1.509,1.509,0,0,1,0-2.6,2.352,2.352,0,0,0,.645-.53A1.909,1.909,0,0,0,20.555,8.3a4.76,4.76,0,0,0-.717-1.532,4.761,4.761,0,0,0-.968-1.387,1.909,1.909,0,0,0-1.411-.378,2.354,2.354,0,0,0-.782.294A1.509,1.509,0,0,1,14.427,4a2.352,2.352,0,0,0-.137-.824A1.909,1.909,0,0,0,13.257,2.145Z"
          transform="translate(-8.2 -8.2)"
          fill="none"
          stroke={strokeColor}
          strokeWidth={1.2}
        />
        <circle
          cx="2.864"
          cy="2.864"
          r="2.864"
          fill="none"
          stroke={strokeColor}
          strokeWidth={1.2}
        />
      </g>
    </svg>
  );
};

export default SettingsIcon;
